import React, { Component } from 'react';
import Modal from 'react-modal';
import FormTable from '../../../Fields/FormTable.js';
import FormTableSelectFilter from '../../../Fields/FormTableSelectFilter.js';
import ControlMessageDetail from './ControlMessageDetail.js';
import ControlMessageNew from './ControlMessageNew.js';
import { getTranslation } from '../../../Utilities/GetTranslation.js'
import { getDateString, getJsonDate, getTimeString, getJsonItem } from '../../../Utilities/JsonFunctions.js';
import { getMessageTypes, getCreateMsgTitle } from '../../../Utilities/SnsExtranetFunctions.js';

declare var globalExtranet;
declare var $;

class ControlMessages extends Component {
    constructor(props) {
        super(props);

        const expanded = this.props.messages.map(() => {return false});
        this.state = { 
            expanded: expanded,
            isOpenAll: false,
            isRead: [] // Internally store read status
        };

        this.openMessageBox = this.openMessageBox.bind(this);
        this.closeMessageBox = this.closeMessageBox.bind(this);
        this.openAllMessages = this.openAllMessages.bind(this);
        this.closeAllMessages = this.closeAllMessages.bind(this);
    }

    openMessageBox() {
        this.setState({openMessageBox: true});
    }

    closeMessageBox() {
        this.setState({openMessageBox: false});

        // Reload parent page
        if (this.props.onReload == null) {
            return;
        }
        this.props.onReload();
    }

    resetRows(isOpen) {
        const expanded = this.props.messages.map(() => {return isOpen});
        this.setState({
            expanded: expanded,
            isOpenAll: isOpen
        });        
    }

    openAllMessages() {
        this.resetRows(true);
    }

    closeAllMessages() {
        this.resetRows(false);
    }

    render() {
        var columns = [
            {
                Header: () => {
                    if (this.state.isOpenAll) {
                        return (
                            <a onClick={this.closeAllMessages}>
                                <i className="fa fa-caret-down" aria-hidden="true"></i><span className="sr-only">Close</span>
                            </a>
                        );
                    } else {
                        return (
                            <a onClick={this.openAllMessages}>
                                <i className="fa fa-caret-right" aria-hidden="true"></i><span className="sr-only">Open</span>
                            </a>
                        );
                    }
                    
                },
                expander: true
            },
            {
                Header: () => {
                    return <span>{getTranslation("sns.general.extranet.filter")} <i className="fa fa-filter" aria-hidden="true"></i></span>
                },
                accessor: "isRead",
                width: 85,
                sortable: false,
                filterMethod: (filter, row) => {
                    switch(filter.value) {
                        case "unread":
                            return !(row.isRead);
                        case "attachment":
                            return row.nrAttachments > 0;
                        default: return true;
                    }
                },
                Filter: ({filter, onChange}) => {
                    return (
                        <div className="select-wrapper">
                            <select
                                onChange={event => onChange(event.target.value)}
                                value={filter ? filter.value : "all"}>
                                <option value="all">{getTranslation("sns.general.extranet.filter.all")}</option>
                                <option value="unread">{getTranslation("sns.general.extranet.filter.unread")}</option>
                                <option value="attachment">{getTranslation("sns.general.extranet.filter.attachment")}</option>
                            </select>
                        </div>
                    );
                },
                Cell: row => (
                    <span>&nbsp;</span>
                    /*<div>
                        {
                            row.value === true ? /// isRead in accessor
                                <i className="fa fa-flag">1</i> :
                                <i className="fa fa-flag">0</i>
                        }
                    </div>*/
                )
            },
            {
                Header: getTranslation("sns.general.extranet.entrydate"),
                accessor: "date",
                width: 225,
                // The Create Message button is in the place of the filter
                // This field is not used as a filter for this column
                Filter: ({filter, onChange}) => {
                    return (
                        <button type="button" className="FormButton btn btn-primary btn-sm" onClick={this.openMessageBox}>
                            <i className="fa fa-pencil" aria-hidden="true"></i>{getCreateMsgTitle(this.props.candidateId, this.props.projectId)}
                        </button>
                    );
                },
                Cell: row => (
                    <span>{getDateString(getJsonDate(row.value))} {getTimeString(getJsonDate(row.value))}</span>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.messagetype"),
                accessor: "type",
                minWidth: 175,
                maxWidth: 200,
                Cell: row => (
                    <span>{getJsonItem(getMessageTypes(), "key", row.value).value}</span>
                ),
                Filter: ({filter, onChange}) => {
                    return (
                        <div className="select-wrapper">
                            <select
                                onChange={event => onChange(event.target.value)}
                                value={filter ? filter.value : ""}>
                                <option value=""></option>
                                {
                                    getMessageTypes().map((x) =>
                                        <option key={x.key} value={x.key}>{x.value}</option>        
                                    )
                                }
                            </select>
                        </div>
                    );
                }                
            },
            {
                Header: () => {
                    return <span><span className="sr-only">{getTranslation("sns.general.extranet.attachment")}</span> &nbsp;&nbsp;&nbsp;<i className="fa fa-paperclip" aria-hidden="true"></i></span>
                },
                accessor: "nrAttachments",
                width: 60,
                filterable: false,
                Cell: row => (
                    <span>
                        {
                            row.value > 0 ?
                                <span><i className="fa fa-paperclip" aria-hidden="true"></i> {row.value}</span> : ""
                        }
                    </span>
                )
            },            
            {
                Header: getTranslation("sns.general.extranet.from"),
                minWidth: 200,
                maxWidth: 250,
                accessor: "from",
                Cell: row => (<span title={row.value}>{row.value}</span>),
                Filter: ({filter, onChange}) => {
                    return (<FormTableSelectFilter filter={filter} onChange={onChange} data={this.props.messages} accessor="from" />);
                }                 
            },
            {
                Header: getTranslation("sns.general.extranet.candidatename"),
                accessor: "candidateName",
                minWidth: 150,
                show: this.props.onNavigateToCandidates != null,
                Cell: row => (
                    <span>
                        {
                            row.value != null ?
                                <a onClick={(e) => this.props.onNavigateToCandidates(row.row._original)}>{row.value}</a> : "/"
                        }
                    </span>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.candidatefirstname"),
                accessor: "candidateFirstName",
                minWidth: 150,
                show: this.props.onNavigateToCandidates != null,
                Cell: row => (
                    <span>
                        {
                            row.value != null ?
                                <a onClick={(e) => this.props.onNavigateToCandidates(row.row._original)}>{row.value}</a> : "/"
                        }
                    </span>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.project"),
                accessor: "project",
                minWidth: 300,
                show: this.props.onNavigateToProjects != null,
                Cell: row => (
                    <span>
                        {
                            row.value != null ?
                                <a title={row.value} onClick={(e) => this.props.onNavigateToProjects(row.row._original)}>{row.value}</a> : ""
                        }
                    </span>
                ),                
                Filter: ({filter, onChange}) => {
                    return (<FormTableSelectFilter filter={filter} onChange={onChange} data={this.props.messages} accessor="project" />);
                },
                filterMethod: (filter, row) => {
                    const id = filter.pivotId || filter.id;
                    if (row[id] !== null) {
                        if(row[id] === undefined)
                            return true;
                        
                        return  row[id].toString().toLowerCase() === filter.value.toString().toLowerCase();
                    }
                } 
            }
        ]

        return (
            <div>
                <FormTable 
                    data={this.props.messages}
                    columns={columns}
                    filterable={true}
                    expanded={this.state.expanded}
                    onExpandedChange={
                        (newExpanded, index) => {
                            this.setState(
                                (oldState) => {
                                    const itemIndex = index[0];
                                    const isExpanded = oldState.expanded[itemIndex];
                                    const newList = oldState.expanded;
                                    newList[itemIndex] = !isExpanded;
                                    return {
                                        expanded: newList
                                    };
                                }
                            );
                        }
                    }
                    onFilteredChange={
                        () => {
                            this.resetRows(false);
                        }
                    }
                    onPageChange={
                        () => {
                            this.resetRows(false);
                        }
                    }                    
                    getTrProps={
                        (state, row, instance) => {
                            if (!(row.row.isRead || this.state.isRead.includes(row.index))) {
                                return {
                                    className: "highlight"
                                }
                            }
                            return {};
                        }
                    }
                    SubComponent={
                        row => {
                            if (!this.state.isRead.includes(row.index)) {
                                this.setState(
                                    (oldState) => {
                                        var isRead = oldState.isRead;
                                        isRead.push(row.index);
                                        return {
                                            isRead: isRead
                                        };
                                    }
                                );
                            }

                            return (
                                <div className="subComponent">
                                    <ControlMessageDetail historyId={row.row._original.historyId} messageId={row.row._original.messageId} />
                                </div>
                            )
                        }
                    }
                    defaultSorted={[{id:"date", desc: true}]}
                />                
                <Modal
                    isOpen={this.state.openMessageBox}
                    onRequestClose={this.closeMessageBox}
                    className="ReactModal"
                    overlayClassName="ReactModalOverlay"                    
                >
                    <ControlMessageNew 
                        projectId={this.props.projectId}
                        projectName={this.props.projectName}
                        candidateId={this.props.candidateId}
                        candidateName={this.props.candidateName}
                        onRequestClose={this.closeMessageBox} />
                </Modal>
            </div>
        );
    }
}

export default ControlMessages;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ControlMessages.js